<template>
	<vue-cookie-accept-decline
		:ref="'cookieBannerSos'"
		:elementId="'cookieBannerSos'"
		:debug="false"
		:position="'center'"
		:type="'floating'"
		:disableDecline="false"
		:transitionName="'slideFromBottom'"
		:showPostponeButton="false"
		@status="cookieStatus"
		@removed-cookie="cookieClickedRemove"
		@clicked-accept="cookieClickedAccept"
		@clicked-decline="cookieClickedDecline"
	>
		<div slot="message">
			{{ $t('consentContent.description1') }}
			<router-link :to="{ name: 'Datenschutz' }">{{
				$t('consentContent.description1a')
			}}</router-link
			>.
		</div>

		<div slot="declineContent">
			{{ $t('consentContent.onlyNeededButton') }}
		</div>

		<div slot="acceptContent">
			{{ $t('consentContent.acceptAllButton') }}
		</div>
	</vue-cookie-accept-decline>
</template>

<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

export default {
	name: 'CookieBanner',
	components: {
		VueCookieAcceptDecline
	},
	methods: {
		cookieClickedAccept() {
			this.$store.commit('onSetCookie')
		},
		cookieClickedDecline() {},
		cookieStatus() {},
		cookieClickedRemove() {}
	},
	mounted() {
		this.$refs.cookieBannerSos.removeCookie()
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_consent.json'),
			en: require('@/i18n/en/eng_consent.json')
		}
	}
}
</script>

<style lang="stylus">
#cookieBannerSos {
    position: fixed;
    bottom: 0;
    background-color: rgba(0,0,0, 0.95);
    width: 100%;
    padding: 35px 50px;
	z-index: 2;
}

.cookie__floating__buttons {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-top: 35px;
    background-color: rgba(0,0,0, 0.95);
}

.cookie__floating__buttons__button--decline {
    color: rgba(255,255,255,0.3);
    background-color: rgba(0,0,0, 0.95);
    border: none;
    margin-right: 35px;
}
.cookie__floating__buttons__button--decline:hover {
    text-decoration: underline;
}

@media (max-width: 500px) {
	.cookie__floating__buttons__button--decline {
		margin-bottom: 25px;
	}
}

.cookie__floating__buttons__button--accept {
    background-color: rgba(11,38,46,0.8);
    color: white;
    border none;
    padding: 10px 20px;
}
.cookie__floating__buttons__button--accept:hover {
    transform: scale(1.1);
    color: red;
}

a, .router-link-exact-active,  a:hover {
    color: red;
}
</style>
